<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <SearchCollapse :expanded="true" title="Geral">
        <NxInput
          name="nome"
          type="text"
          label="Nome do Arquivo:"
          placeholder="Digite o nome"
          @update:value="handleInputUpdate('nomeOriginal', $event)"
        ></NxInput>
        <NxInputDate variable="de Envio" :maxToday="true"  @update:value="handleInputUpdate('dataEnvio', $event, false)"/>
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import employeeTypes from '@/enums/enumEmployeeTypes.js'
import {NxInputDate} from '@/components/nexum/components/custom-inputs/index.js'

export default {
  name: 'SidebarAnexos',
  components: { SidebarSearch, SearchCollapse, NxInputDate },
  data () {
    return {
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        nomeOriginal: null,
        dataEnvio: null
      },
      employeeTypes: employeeTypes
    }
  },
  methods: {
    submitForm () {
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName] = clean ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '') : inputedValue
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/attachments/components/search/SidebarAnexos.vue